import { createSelector } from 'reselect'

import { CryptoRewardsReducer } from 'components/features/rewards/rewardsPane/types/store'
import { getPaneReducerStateSelector } from 'components/features/rewards/rewardsPane/store/selectors/generalReducer'
import { minRedemptionAmountSelector, usdBalanceSelector, rewardSummarySelector } from 'selectors/bountySelectors'
import { CryptoCurrencyId } from 'components/features/rewards/rewardsPane/types/cryptoCurrency'
import { State } from 'interfaces/state'
import { getCryptoCurrenciesDefaultCurrencyIdOrNullSelector } from 'components/features/rewards/rewardsPane/store/selectors/currencies'

export function getUserRewardsReducerStateSelector (state: State): CryptoRewardsReducer {
  return getPaneReducerStateSelector(state).cryptoRewards
}

export function getUserRewardsSumUSDSelector (state: State): number {
  return usdBalanceSelector(state) ?? 0
}

export function getUserRewardsOnHoldSumUSDSelector (): number {
  // TODO - we don't have this sum currently
  return 0
}

export function getAutoinvestCurrencyIdOrNullSelector (state: State): CryptoCurrencyId | null {
  return rewardSummarySelector(state)?.autoinvest_ticker ?? null
}

export function isAutoinvestEnabledSelector (state: State): boolean | null {
  return rewardSummarySelector(state)?.is_autoinvest_on ?? null
}

export function minimalRewardsBalanceUSDForInvestingSelector (state: State): number {
  return Number(minRedemptionAmountSelector(state))
}

export const getAutoinvestOrDefaultCurrencyIdOrNullSelector = createSelector(
  getAutoinvestCurrencyIdOrNullSelector,
  getCryptoCurrenciesDefaultCurrencyIdOrNullSelector,
  (
    currencyIdChosenForAutoinvestmentsOrNull: CryptoCurrencyId | null,
    currencyIdChosenForAutoinvestmentsDefaultOrNull: CryptoCurrencyId | null,
  ): CryptoCurrencyId | null => (
    currencyIdChosenForAutoinvestmentsOrNull ?? currencyIdChosenForAutoinvestmentsDefaultOrNull ?? null
  )
)
